import useDeliverLastOld from '@hypatia/react-hooks/useDeliverLastOld'
import screenSize$ from '@hypatia/utils/window/screenSize$'

export default function useScreenDim() {
    const { value } = useDeliverLastOld(screenSize$)
    return value!
}
